import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d2d7bf2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-wrapper" }
const _hoisted_2 = { class: "company" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = { class: "user" }
const _hoisted_5 = { class: "dialog-footer" }

import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import defaultUserIcon from '@/assets/icons/icon-user-default.png'
import type { FormInstance } from 'element-plus'
import { ElMessage } from 'element-plus'
import { encode } from '@/utils'
import { passwordReg, CODE_ENUM, PLATFORM_TYPE } from '@/common'
import { oauthRemoveToken, passwordUpdate } from '@/api'
import { useGlobalStore } from '@/stores/global'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const globalStore = useGlobalStore()

const currentPlatform = computed(() => {
  return globalStore.platformType === PLATFORM_TYPE.OPERATION
    ? '天数TianShu 运营平台'
    : '数据中台'
})

const toPlatform = computed(() => {
  return globalStore.platformType === PLATFORM_TYPE.OPERATION
    ? '数据中台'
    : '运营中心'
})

const changePlatform = () => {
  globalStore.changePlatformType()
}

const dialogVisible = ref(false)
const router = useRouter()

const formData = ref({
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
})
const validator = (rule: any, value: any, callback: any) => {
  if (value !== formData.value.newPassword) {
    callback('两次输入的密码不匹配')
  } else {
    callback()
  }
}

const rules = {
  oldPassword: [{ required: true, message: '请输入原密码' }],
  newPassword: [
    { required: true, message: '请输入新密码' },
    {
      pattern: passwordReg,
      message: '6-30位字符串',
    },
  ],
  confirmPassword: [
    { required: true, message: '请再次输入新密码' },
    {
      validator,
    },
  ],
}

const dropdownList = [
  {
    command: 'updatePassword',
    label: '修改密码',
  },
  {
    command: 'signOut',
    label: '退出',
  },
]

const handleCommand = async (command: string) => {
  if (command === 'updatePassword') {
    dialogVisible.value = true
  } else if (command === 'signOut') {
    oauthRemoveToken({
      token: localStorage.getItem('WX_Authorization'),
    }).finally(() => {
      router.push('/login')
      localStorage.removeItem('WX_Authorization')
      localStorage.removeItem('WX_AuthorizationUser')
    })
  }
}

const loading = ref(false)
const formRef: any = ref<FormInstance>()

const handleClose = () => {
  dialogVisible.value = false
  formRef.value.resetFields()
}

const handleUpdatePassword = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      const { oldPassword, newPassword } = formData.value
      loading.value = true
      const res: any = await passwordUpdate({
        oldPassword: encode(oldPassword),
        newPassword: encode(newPassword),
      }).finally(() => {
        loading.value = false
      })
      if (res?.code === CODE_ENUM.SUCCESS) {
        ElMessage({
          message: '修改密码成功',
          type: 'success',
        })
        handleClose()
      } else if (res?.code === 20000) {
        ElMessage({
          message: '原密码错误',
          type: 'error',
        })
      } else {
        ElMessage({
          message: res.msg,
          type: 'error',
        })
      }
    }
  })
}

const userName = ref('')
onMounted(() => {
  userName.value = localStorage.getItem('WX_AuthorizationUser') || ''
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(currentPlatform.value), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: changePlatform,
          type: "primary",
          class: "ws_mr25"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(toPlatform.value), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_dropdown, { onCommand: handleCommand }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dropdownList, (item, index) => {
                  return _createVNode(_component_el_dropdown_item, {
                    key: index,
                    command: item.command
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["command"])
                }), 64))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_avatar, {
                size: 25,
                src: _unref(defaultUserIcon)
              }, null, 8, ["src"]),
              _createElementVNode("span", null, _toDisplayString(userName.value), 1)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
      title: "修改密码",
      width: "508px",
      "before-close": handleClose,
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, { onClick: handleClose }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            loading: loading.value,
            type: "primary",
            onClick: handleUpdatePassword
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 确认 ")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          class: "form ws_mr15",
          "label-width": "100px",
          model: formData.value,
          rules: rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "oldPassword",
              label: "旧密码"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.oldPassword,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.oldPassword) = $event)),
                  modelModifiers: { trim: true },
                  type: "password",
                  placeholder: "请输入旧密码",
                  maxlength: "50",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "newPassword",
              label: "新密码"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.newPassword,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.newPassword) = $event)),
                  modelModifiers: { trim: true },
                  type: "password",
                  placeholder: "请输入新密码",
                  maxlength: "50",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "confirmPassword",
              label: "确认新密码"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.confirmPassword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.confirmPassword) = $event)),
                  modelModifiers: { trim: true },
                  type: "password",
                  placeholder: "请再次输入新密码",
                  maxlength: "50",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})